import React from 'react'
import Yields from '../components/yields'

export default ()=>(
    <Yields />
)